var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"pagination"},[(_vm.totalPages > 1 && _vm.showPages.length && _vm.showPages[0] != 1)?_c('button',{staticClass:"big-btn",on:{"click":_vm.backPages}},[_vm._v(" Anterior ")]):_vm._e(),_vm._l((_vm.showPages),function(btn){return _c('button',{key:btn,class:_vm.currentPage == btn ? 'active' : '',on:{"click":function($event){return _vm.tableRequest(btn)}}},[_vm._v(" "+_vm._s(btn)+" ")])}),(
			_vm.totalPages > 1 &&
			_vm.alwaysShowLast &&
			_vm.currentPage != _vm.totalPages &&
			_vm.currentPage + 5 <= _vm.totalPages &&
			_vm.showPages[_vm.showPages.length - 1] != _vm.totalPages
		)?_c('span',{staticClass:"dots"},[_vm._v(" ... ")]):_vm._e(),(
			_vm.totalPages > 1 &&
			_vm.alwaysShowLast &&
			_vm.currentPage != _vm.totalPages &&
			_vm.currentPage + 5 <= _vm.totalPages &&
			_vm.showPages[_vm.showPages.length - 1] != _vm.totalPages
		)?_c('button',{on:{"click":function($event){return _vm.tableRequest(_vm.totalPages)}}},[_vm._v(" "+_vm._s(_vm.totalPages)+" ")]):_vm._e(),(_vm.totalPages > 1 && _vm.showPages.length && _vm.showPages[_vm.showPages.length - 1] != _vm.totalPages)?_c('button',{staticClass:"big-btn",on:{"click":_vm.morePages}},[_vm._v(" Próxima ")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }